<template>
  <dropdown-btn>
    {{ computedLabel }}
    <ul slot="actions">
      <li v-if="doesHavePermission(importPermission) && showImport">
        <button @click="importEvent">
          <icon type="import" color="inherit"></icon>
          {{ trans("items.import") }}
        </button>
      </li>

      <li v-if="doesHavePermission(importLinesPermission) && showImportLines">
        <button @click="importLinesEvent">
          <icon type="import" color="inherit"></icon>
          {{ trans("lots.import_lines") }}
        </button>
      </li>

      <li v-if="doesHavePermission(exportPermission) && showExport">
        <button @click="exportEvent">
          <icon type="export" color="inherit"></icon>
          {{ trans("items.export") }}
        </button>
      </li>

      <li v-if="doesHavePermission(exportLinesPermission) && showExportLines">
        <button @click="exportLinesEvent">
          <icon type="export" color="inherit"></icon>
          {{ trans("lots.export_lines") }}
        </button>
      </li>

      <slot name="custom-actions"></slot>
    </ul>
  </dropdown-btn>
</template>

<script type="text/babel">
export default {
  name: "import-export",

  props: {
    showImport: { default: false },
    showImportLines: { default: false },
    importPermission: { default: "" },
    importLinesPermission: { default: "" },

    showExport: { default: false },
    showExportLines: { default: false },
    exportPermission: { default: "" },
    exportLinesPermission: { default: "" },
  },

  computed: {
    computedLabel() {
      let hasImport = this.showImport || this.showImportLines;
      let hasExport = this.showExport || this.showExportLines;
      if (hasImport && hasExport) {
        return `${trans("items.import")} / ${trans("items.export")}`;
      }
      if (hasImport) {
        return `${trans("items.import")}`;
      }
      if (hasExport) {
        return `${trans("items.export")}`;
      }
    },
  },

  methods: {
    importEvent() {
      this.$emit("import");
    },

    exportEvent() {
      this.$emit("export");
    },

    importLinesEvent() {
      this.$emit("import-lines");
    },

    exportLinesEvent() {
      this.$emit("export-lines");
    },
  },
};
</script>
